export const products = [
  {
    id: 1,
    name: "Organic Cloud Swaddle",
    subtitle: "100% GOTS Cotton",
    price: 48.00,
    category: "Registry Essentials",
    image: "https://images.unsplash.com/photo-1595966597793-279fd75c2e99?auto=format&fit=crop&q=80&w=800",
    isNew: true,
    tag: "Most Gifted",
    stock: 12
  },
  {
    id: 2,
    name: "Gentle Touch Bath Set",
    subtitle: "Hypoallergenic & Pure",
    price: 62.00,
    category: "Care & Bath",
    image: "https://images.unsplash.com/photo-1544126592-807ade215a0b?auto=format&fit=crop&q=80&w=800",
    tag: "New Arrival",
    stock: 5
  },
  {
    id: 3,
    name: "Heirloom Knit Throw",
    subtitle: "Hand-finished Details",
    price: 85.00,
    category: "Nursery Decor",
    image: "https://images.unsplash.com/photo-1584824388145-89f81a7b6924?auto=format&fit=crop&q=80&w=800",
    stock: 0
  },
  {
    id: 4,
    name: "Ergonomic Linen Wrap",
    subtitle: "Breathable Support",
    price: 115.00,
    category: "On the Go",
    image: "https://images.unsplash.com/photo-1543788303-c07a04803da9?auto=format&fit=crop&q=80&w=800",
    tag: "Essential",
    stock: 8
  }
];

export const reviews = [
  {
    id: 1,
    name: "Adeline Vance",
    role: "First-time Mother",
    content: "The quality of the linen wrap changed our daily walks. It's not just a product; it's a piece of our new rhythm. Truly the most thoughtful registry experience I've had.",
    rating: 5,
    location: "Austin, TX"
  },
  {
    id: 2,
    name: "Julianna Moss",
    role: "Mother of Three",
    content: "I've tried many brands over the years, but LumaBaby's commitment to safety and aesthetics is unmatched. The Heirloom Knit is a treasure we'll keep forever.",
    rating: 5,
    location: "Portland, OR"
  }
];

export const faqs = [
  {
    question: "How do you ensure product safety?",
    answer: "Every LumaBaby item undergoes triple-stage testing. We partner with GOTS-certified suppliers to ensure our fabrics are free from harmful chemicals, heavy metals, and synthetic pesticides."
  },
  {
    question: "Can I customize my registry gift bundles?",
    answer: "Yes, our 'Curate Your Own' feature allows you to select individual essentials to build a bespoke bundle. Each custom bundle still receives our signature premium gift packaging."
  },
  {
    question: "What is the LumaBaby Registry Guarantee?",
    answer: "We offer a 1-year warranty on all registry essentials and a 90-day 'Gentle Return' window. If an item doesn't fit your needs, we make the exchange process effortless."
  }
];